<div bsModal #projectimgmodal="bs-modal" (onShown)="onShown()" class="modal right " tabindex="-1" role="dialog" aria-labelledby="projectimgmodal" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog-rignt ">
        <div class="row h-100">

            <div class="modal-content col">

                <div class="modal-header mb-6">
                    <div role="tablist">
                         <div class="card-title  mb-0 font-weight-boldest h4"> {{'UploadPhoto' | localize}}</div>
                    </div>
                    <button type="button" data-dismiss="modal" aria-label="Close" class="close mt-2" (click)="saveCancel()">
                        <i aria-hidden="true" class="ki ki-close"></i>
                    </button>
                </div>
                  <div class="modal-body" id="kt_widget2_tab1_content"  class="tab-pane side-border mx-7">
                    <div style="border: 1px solid #9EA4AC">
                        <div class="text-center mt-10">
                            <div class="image-input-wrapper">
                                <div *ngIf="showImgModal">
                                    <img class="border-radius-2 h-115px w-210px rounded" *ngIf="imagePathModal != ''" [src]="imagePathModal">
                                    <img *ngIf="imagePathModal == '' " class="imgage-background" />
                                </div>
                                <div *ngIf="showImgModal">
                                    <label class="mt-3" (click)="removeImage()">
                                        <a class="blue cursor-pointer">
                                            {{'RemovePhoto' | localize}}
                                        </a>
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="!showImgModal">
                                <label class="mt-3 " title="">
                                    <input #fileInput class="" autocomplete="off" type="file" id="UploadFile" style="display: none"
                                           (change)="getfileContent($event.target.files)" name="profile_avatar"
                                           accept=".png, .jpg, .jpeg" required>
                                    <a class="blue cursor-pointer font-size-h6">
                                        {{'ClickHere' | localize}}
                                    </a><br />
                                </label>
                                <div class="uploadPhoto font-size-h6 font-weight-bolder">{{"Touploadyourphoto" | localize}}</div>
                                <br />
                            </div>
                        </div>
                        <div class="text-center mt-10">
                            <label class="font-size-sm font-weight-bold">{{"RecommendedFormat" | localize}}</label>
                        </div>
                        <div class="text-center">
                            <label class="font-size-sm font-weight-bold">{{"RecommendedSize" | localize}}</label>
                        </div>

                    </div>
                    <div class="col-md-12">
                        <div class="float-right mt-10">
                            <button class="btn btn-square btn-outline-danger px-5 mr-1" data-dismiss="projectimgmodal"
                                    (click)="saveCancel()">
                                {{"Cancel" | localize}}
                            </button>
                            <button class="btn btn-square btn-primary px-8" data-dismiss="projectimgmodal" (click)="savePhoto()"  [disabled]="isImage">
                                {{"Upload" | localize}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<warning-popup-project #SignModalPopup message="{{'InvalidImageFormat' | localize}}" submessage="{{'Pleaseselectpngjpgorjpegformattouploadimage'| localize}}"></warning-popup-project>

